/**
 * Created by filatov on 16.09.2015.
 */
import LeaveHTMLPreviewBaseColumnsStrategy from './LeaveHTMLPreviewBaseStrategy'

export default function LeaveHTMLPreviewTimeAndBalanceOnlyStrategy() {}

LeaveHTMLPreviewTimeAndBalanceOnlyStrategy.prototype = new LeaveHTMLPreviewBaseColumnsStrategy();

LeaveHTMLPreviewTimeAndBalanceOnlyStrategy.prototype.init = function( timeFormat, balanceQualifier )
{
    LeaveHTMLPreviewBaseColumnsStrategy.prototype.init.call( this, timeFormat );

    this.balanceColumnsRender = this._initBalanceColumnsRenderConstructor(balanceQualifier, true);
    return this;
};

LeaveHTMLPreviewTimeAndBalanceOnlyStrategy.prototype.addFirstHeaderRowCells = function( firstHeaderRow )
{
    this.addCreatedCell( firstHeaderRow, this.createTotalLeaveTimeCell());
    this.addCreatedCell( firstHeaderRow, this.createLeaveHeaderCell() );
    this.addCreatedCell( firstHeaderRow, this.createLeaveHeaderCell() );
    this.balanceColumnsRender.addHeaderFirstRowCells( firstHeaderRow );
};

LeaveHTMLPreviewTimeAndBalanceOnlyStrategy.prototype.addSecondHeaderRowCells = function( secondHeaderRow ) {
    this.balanceColumnsRender.addHeaderSecondRowCells( secondHeaderRow );
};

LeaveHTMLPreviewTimeAndBalanceOnlyStrategy.prototype.getStrategyCssClass = function ()
{
    return "timeAndBalance"  + " " + this.balanceColumnsRender.getRenderSpecificCssClass();
};

LeaveHTMLPreviewTimeAndBalanceOnlyStrategy.prototype.addDataCells = function( row )
{
    this.addTimeValueCell(row);
    this.addTimeValueCell(row);
    this.addTimeValueCell(row);
    this.balanceColumnsRender.addValueCells( row );
};



// WEBPACK FOOTER //
// ./web/js/reports/preview/html/leave/LeaveHTMLPreviewTimeAndBalanceStrategy.js